import React from 'react';

const BenefitsContent = () => (
  <section>
    <p>
      Te informamos que a partir de hoy mejoramos tu experiencia. Y es por eso que, al momento de
      gestionar una autorización o transaccionar una prestación, podrás buscar y seleccionar
      unicamente aquellas prestaciones que tengas dentro de tu convenio. De esta forma será mas ágil
      la identificación de la prestación y el resultado de la gestión.
    </p>
    <p>
      Recordá que ingresando los trámites con la prestación a autorizar identificada facilita y
      agiliza las gestiones.
    </p>
  </section>
);

export default BenefitsContent;
